export default __webpack_public_path__ + "static/media/7.85010314.jpg";